import React from "react";
import mouood_main_logo from '../../Images/mouood_main_logo.png';
import headerLogo from '../../Images/headerLogo.png';
import '../../Styles/Components/PublicForms/Not_Found.css';

const Not_Found = ()=>
{
    return(<div className="Not_Found">

        <img src = {headerLogo}/>
        <p>صفحه مورد نظر شما وجود ندارد</p>

    </div>)

}

export default Not_Found;